export default {
  seo: {
    title: "Raamkruk vervangen Eindhoven | Alle merken & kleuren | Vanaf €85",
    description:
      "Versleten of kapotte raamkruk in Eindhoven? Wij vervangen alle merken in elke kleur — wit, RAL, RVS of brons. Vanaf €85. Bel 040 798 7470.",
  },
  breadcrumb: {
    home: "Home",
    diensten: "Diensten",
    current: "Raamkruk vervangen",
  },
  hero: {
    pill: "DIENST — RAAMKRUK VERVANGEN",
    h1: "Raamkruk vervangen in Eindhoven",
    subhead:
      "Versleten, gebroken of gewoon toe aan een nieuwe look? Wij vervangen raamkrukken van alle merken in elke kleur — vakkundig en met 10 jaar garantie.",
    usps: [
      "Vanaf €85 per kruk",
      "Klaar in 30 minuten",
      "Alle merken en kleuren",
    ],
    ctaPhone: "📞 040 798 7470",
    ctaForm: "Gratis offerte",
  },
  intro: {
    h2: "Wanneer is raamkruk vervangen nodig?",
    p1:
      "De raamkruk is het onderdeel dat u dagelijks het meest gebruikt. Logisch dus dat hij na 10 tot 20 jaar tekenen van slijtage vertoont: hij draait zwaar, klemt of komt los van het mechanisme. Soms is hij gewoon esthetisch verouderd.",
    p2:
      "Vervangen is bij ons een kleine ingreep met groot effect. Een nieuwe kruk geeft uw raam direct meer comfort, betere bediening en — bij keuze voor een afsluitbare kruk — extra inbraakwering. Vaak klaar binnen 30 minuten per stuk.",
    p3:
      "Wij werken met alle grote merken: Hoppe, FSB, Roto, Maco en Winkhaus. En in elke kleur: standaard wit, alle RAL-kleuren, geborsteld RVS, gepolijst chroom of klassiek brons. Wij hebben de meeste varianten op voorraad.",
  },
  merkenKleuren: {
    h2: "Alle merken, alle kleuren",
    rows: [
      {
        title: "Hoppe",
        text: "Duits topmerk, de meest gebruikte raamkruk in Nederland. Beschikbaar in alle kleuren en afsluitbare uitvoering.",
      },
      {
        title: "FSB",
        text: "Premium design uit Duitsland. Strakke moderne lijnen voor minimalistische woningen en designinterieurs.",
      },
      {
        title: "Roto, Maco, Winkhaus",
        text: "Vaak standaard op fabriekskozijnen. Wij vervangen 1-op-1 of upgraden naar betere kwaliteit.",
      },
      {
        title: "Kleuren op maat",
        text: "Standaard wit, RAL 9016, RAL 9005 zwart, geborsteld RVS, chroom, antiek brons of gepolijst messing.",
      },
    ],
  },
  typesKrukken: {
    h2: "Welke raamkrukken vervangen wij?",
    items: [
      { num: "01", title: "Standaard raamkruk", text: "Draaien en kiepen" },
      { num: "02", title: "Afsluitbare kruk", text: "Extra inbraakwering met sleutel" },
      { num: "03", title: "Knopkruk", text: "Compact en strak design" },
      { num: "04", title: "Schuifpui-greep", text: "Specifiek voor schuifpuien" },
      { num: "05", title: "Balkondeur-kruk", text: "Tweezijdige bediening" },
      { num: "06", title: "Designkruk", text: "FSB, Hoppe Atlanta, Hoppe London" },
    ],
  },
  werkwijze: {
    h2: "Werkwijze raamkruk vervangen",
    steps: [
      { num: "01", title: "Aanvraag", text: "Foto of merk doorgeven helpt" },
      { num: "02", title: "Bestelling", text: "Standaard op voorraad, anders 2-5 dagen levertijd" },
      { num: "03", title: "Plaatsing", text: "Snel verwisseld, vaak in 30 min per kruk" },
      { num: "04", title: "Garantie", text: "10 jaar schriftelijk" },
    ],
  },
  prijzen: {
    h2: "Wat kost een raamkruk vervangen?",
    note:
      "Excl. 21% BTW. Materiaal op werkelijke kostprijs. Staffelkorting vanaf 5 stuks.",
    rows: [
      { service: "Diagnose ter plaatse", price: "Gratis", time: "15 min" },
      { service: "Standaard kruk vervangen", price: "€85", time: "30 min" },
      { service: "Afsluitbare kruk vervangen", price: "€115", time: "30 min" },
      { service: "Designkruk (Hoppe, FSB)", price: "Vanaf €145", time: "30 min" },
      { service: "Schuifpui-greep vervangen", price: "€95", time: "30 min" },
      { service: "Bij meerdere ramen (per stuk)", price: "Vanaf €65", time: "-" },
    ],
  },
  waaromWij: {
    h2: "Waarom kiezen voor ons?",
    reasons: [
      { num: "01", title: "Alle merken op voorraad", text: "Hoppe, FSB, Roto, Maco, Winkhaus" },
      { num: "02", title: "Elke kleur leverbaar", text: "Standaard tot exclusief" },
      { num: "03", title: "Snel geplaatst", text: "Vaak 30 min per kruk" },
      { num: "04", title: "10 jaar schriftelijke garantie", text: "Op alle werkzaamheden" },
    ],
  },
  faq: {
    h2: "Veelgestelde vragen",
    items: [
      {
        q: "Hoe weet ik welke kruk op mijn raam past?",
        a:
          "De meeste krukken zijn universeel, maar het type mechanisme (vierkant stift) moet kloppen. Een foto of merknaam helpt. Wij meten ter plaatse en hebben de meest voorkomende stiftmaten op voorraad.",
      },
      {
        q: "Is een afsluitbare kruk zinvol?",
        a:
          "Absoluut. Een afsluitbare raamkruk is een snelle en effectieve manier om extra inbraakwering toe te voegen, zonder de ramen te vervangen. Zeker aan te raden op begane grond en in achterkamers.",
      },
      {
        q: "Mogen alle ramen dezelfde kruk?",
        a:
          "Ja, zolang de stiftmaat gelijk is. Vaak combineren klanten standaard krukken op bovenverdieping met afsluitbare krukken beneden voor consistente uitstraling en optimale beveiliging.",
      },
      {
        q: "Wat is de levertijd van designkrukken?",
        a:
          "Hoppe en FSB standaarduitvoeringen hebben wij op voorraad. Speciale kleuren of uitvoeringen bestellen wij bij de fabriek; levertijd 2 tot 5 werkdagen.",
      },
      {
        q: "Kan ik een raamkruk zelf vervangen?",
        a:
          "Met de juiste stift en schroevendraaier is het een eenvoudige klus. Wij adviseren u graag. Wilt u zekerheid en garantie? Laat het door ons doen voor €85.",
      },
    ],
  },
  interneLinks: {
    h2: "Gerelateerde diensten",
    cards: [
      {
        title: "Kozijnreparatie",
        url: "/kozijn-reparatie/",
        text: "Professionele herstel van beschadigde kozijnen en onderdelen",
      },
      {
        title: "Draaikiepraam reparatie",
        url: "/draaikiepraam-reparatie/",
        text: "Klemt uw draaikiepraam? Wij repareren en stellen af in 30-45 minuten",
      },
      {
        title: "Schuifpui reparatie",
        url: "/schuifpui-reparatie/",
        text: "Rollers, rails en sluitwerk herstellen voor een soepele schuifpui",
      },
    ],
  },
  ctaBanner: {
    h2: "Raamkruk vervangen in Eindhoven?",
  },
  offerteForm: {
    h2: "Gratis offerte aanvragen",
    steps: ["Aantal", "Type kruk", "Contact"],
    step1: {
      label: "Hoeveel krukken wilt u vervangen?",
      options: ["1 kruk", "2-4 krukken", "5-10 krukken", "10+ krukken"],
    },
    step2: {
      label: "Welk type raamkruk?",
      options: [
        "Standaard kruk",
        "Afsluitbare kruk",
        "Designkruk",
        "Weet ik niet / wil advies",
      ],
    },
    step3: {
      firstName: "Voornaam",
      lastName: "Achternaam",
      phone: "Telefoonnummer",
      email: "E-mailadres",
      postcode: "Postcode",
      photo: "Foto van uw huidige kruk (optioneel)",
      message: "Opmerkingen",
      messagePlaceholder:
        "Beschrijf uw wensen, merk of kleurvoorkeur...",
      back: "Terug",
      next: "Volgende",
      submit: "Offerte aanvragen",
      gdpr:
        "Door te verzenden gaat u akkoord met onze privacyvoorwaarden.",
    },
    success: {
      title: "Offerte aanvraag verzonden",
      body: "Wij nemen binnen 2 uur contact met u op.",
    },
  },
};